import React, { useEffect, useState } from "react";
import { set_order_detail } from "../../../../redux/actions/OrdersAction";
import { connect } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./shipment.scss";
import ShipmentItem from "./ShipmentItem";
import { GoPackage } from "react-icons/go";

const classname = ["status", "orange-status", "red-status"];

const pending = (
  <Row className="progress g-0 mt-1">
    <Col xs={3} md={3} className="bar"></Col>
    <Col xs={3} md={3} className="default-bar"></Col>
    <Col xs={3} md={3} className="default-bar"></Col>
    <Col xs={3} md={3} className="default-bar"></Col>
  </Row>
);
const processing = (
  <Row className="progress g-0 mt-1">
    <Col xs={3} md={3} className="bar"></Col>
    <Col xs={3} md={3} className="bar"></Col>
    <Col xs={3} md={3} className="default-bar"></Col>
    <Col xs={3} md={3} className="default-bar"></Col>
  </Row>
);

const shipped = (
  <Row className="progress g-0 mt-1">
    <Col xs={3} md={3} className="bar"></Col>
    <Col xs={3} md={3} className="bar"></Col>
    <Col xs={3} md={3} className="bar"></Col>
    <Col xs={3} md={3} className="default-bar"></Col>
  </Row>
);

const delivered = (
  <Row className="progress g-0 mt-1">
    <Col xs={3} md={3} className="bar"></Col>
    <Col xs={3} md={3} className="bar"></Col>
    <Col xs={3} md={3} className="bar"></Col>
    <Col xs={3} md={3} className="bar"></Col>
  </Row>
);

const cancelled = (
  <Row className="progress g-0 mt-1">
    <Col xs={3} md={3} className="red-bar"></Col>
    <Col xs={3} md={3} className="red-bar"></Col>
    <Col xs={3} md={3} className="red-bar"></Col>
    <Col xs={3} md={3} className="red-bar"></Col>
  </Row>
);

const rejected = (
  <Row className="progress g-0 mt-1">
    <Col xs={3} md={3} className="red-bar"></Col>
    <Col xs={3} md={3} className="red-bar"></Col>
    <Col xs={3} md={3} className="red-bar"></Col>
    <Col xs={3} md={3} className="red-bar"></Col>
  </Row>
);

const partially_returned = (
  <Row className="progress g-0 mt-1">
    <Col xs={3} md={3} className="orange-bar"></Col>
    <Col xs={3} md={3} className="orange-bar"></Col>
    <Col xs={3} md={3} className="orange-bar"></Col>
    <Col xs={3} md={3} className="orange-bar"></Col>
  </Row>
);

const fully_returned = (
  <Row className="progress g-0 mt-1">
    <Col xs={3} md={3} className="red-bar"></Col>
    <Col xs={3} md={3} className="red-bar"></Col>
    <Col xs={3} md={3} className="red-bar"></Col>
    <Col xs={3} md={3} className="red-bar"></Col>
  </Row>
);

const Shipment = (props) => {
  const [barStatus, setBarStatus] = useState(1);
  useEffect(() => {
    switch (props.orderDetail?.shipment?.status.toLowerCase()) {
      case "cancelled":
        setBarStatus(2);
        break;
      case "rejected":
        setBarStatus(2);
        break;
      case "partially_returned":
        setBarStatus(1);
        break;
      case "fully_returned":
        setBarStatus(2);
        break;
      default:
        setBarStatus(0);
    }
  }, [props.orderDetail?.shipment?.status]);

  return (
    <div className="shipment-desktop custom-card-2 mt-3">
      {props.orderDetail?.shipment && (
        <div className="wrapper">
          <div className="shipment-summary vertical-separator px-2 pt-3 pb-2">
            <Row className="g-0">
              <Col md={12} className="pb-2">
                <span className="shipment-title text-uppercase faded-black-2-text fw-600 mr-3">
                  <GoPackage className="me-2" />
                  Shipment {props.orderDetail?.id}
                </span>
                <span className="shipment-number faded-black-2-text"></span>
              </Col>
            </Row>

            {props.orderDetail?.shipment?.status && (
              <>
                {props.orderDetail?.shipment?.status === "pending" && pending}
                {props.orderDetail?.shipment?.status === "cancelled" &&
                  cancelled}
                {props.orderDetail?.shipment?.status === "rejected" && rejected}
                {props.orderDetail?.shipment?.status === "processing" &&
                  processing}
                {props.orderDetail?.shipment?.status === "shipped" && shipped}
                {props.orderDetail?.shipment?.status === "delivered" &&
                  delivered}
                {props.orderDetail?.shipment?.status === "partially_returned" &&
                  partially_returned}
                {props.orderDetail?.shipment?.status === "fully_returned" &&
                  fully_returned}
              </>
            )}

            <div className={classname[barStatus]}>
              <div className="row g-0">
                <div className="col-md-6 fw-700 text-uppercase mt-1">
                  {props.orderDetail?.shipment?.status.includes("_")
                    ? props.orderDetail.shipment?.status.replace("_", " ")
                    : props.orderDetail.shipment?.status}
                </div>
              </div>
            </div>
          </div>
          <div className="shipment-items">
            {props.orderDetail?.shipment.line_items?.map((shipmentItem) => (
              <ShipmentItem
                shipmentItem={shipmentItem}
                key={shipmentItem.id}
                currency={props.orderDetail?.currency}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    orderDetail: state.order.orderDetail,
  };
};

const mapDispatchToProps = { set_order_detail };

export default connect(mapStateToProps, mapDispatchToProps)(Shipment);
